export default __webpack_public_path__ + "static/media/adress.43344ec7.svg";